import { makeStyles } from "@material-ui/core";
import clsx from "clsx";
import React, { useEffect, useRef, useState } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import SplitPane from "react-split-pane";
import { bindActionCreators } from "redux";
import "../../components/labourerDetails/labourerDetails.css";
import { setSelectedLabourer } from "../../redux/gantt/ganttActions";
import { filterTasklist, onShowTasklist } from "../../redux/tasklist/tasklistActions";
import ShowOverlapsModal from "../assignTask/showOverlapsModal";
import DateDomain from "../dateDomain/dateDomain";
import MultidayGantt from "../gantt/multidayGantt";
import Help from "../header/headerActions/help";
import Profile from "../header/headerActions/profile";
import Settings from "../header/headerActions/settings";
// Header and actions
import { MainHeader } from "../header/mainHeader";
import LabourerDrawerForm from "../manageLabourers/manageLabourerDrawer/labourerDrawerForm";
import Sidebar from "../sidebar/sidebar";
import OverallSummary from "../summaryBars/overallSummary";
import Tasks from "../tasks/tasks";
import { Title } from "../common/title/title";
import "./dashboard.css";

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
    },
    splitPane: {
        maxWidth: `calc(100% - ${49}px)`,
        transition: theme.transitions.create(["margin", "width"], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    splitPaneShift: {
        maxWidth: `calc(100% - ${240}px)`,
        transition: theme.transitions.create(["margin", "width"], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawer: {
        zIndex: 2,
        top: "100px",
        height: "345px",
        transition: theme.transitions.create(["margin", "width"], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
}));

export const Dashboard = (props) => {
    const [dragging, setDragging] = useState(false);
    const [drawerHeight, setDrawerHeight] = useState({});
    const [pane2Ref, setPane2Ref] = useState(null);
    const paneRef = useRef(null);
    const classes = useStyles();
    const [drawerProps, setDrawerProps] = useState({
        open: false,
        data: "",
        create: false,
    });
    const [filteredData, setFilteredData] = useState({
        tasks: props.tasks,
        technicians: props.technicians,
    });

    useEffect(() => {
        setDrawerProps({
            open: true,
            data: props.selectedLabourer,
            create: false,
        });
    }, [props.selectedLabourer]);

    useEffect(() => {
        if (paneRef.current && paneRef.current.pane2) {
            setPane2Ref(paneRef.current.pane2);
        }
    }, [paneRef]);

    useEffect(() => {
        const contractNumbers = props.filter.items.map((item) => item.contractNumber);
        const tasks = props.tasks
            ? props?.tasks
                  ?.filter((task) => props?.allStatuses?.all || props?.filter?.all || contractNumbers.includes(task.contractNumber))
                  .filter((item) => !props?.zones || props?.zones?.all || props?.zones?.items?.includes(item?.zone))
            : [];
        const technicians = props.filter.all
            ? props.technicians
            : contractNumbers.length === 0
            ? []
            : props.technicians.filter(
                  (tech) =>
                      tech.contracts.length === 0 ||
                      tech.contracts.map((contract) => contract.contractNumber).filter((value) => contractNumbers.includes(value)).length > 0,
              );

        setFilteredData({
            tasks,
            technicians,
        });
    }, [props.filter, props.tasks, props.technicians, props.zones]);

    return (
        <div>
            <MainHeader subtitle="CMIS" actions={[<Help />, <Settings />, <Profile />]} />
            <div className={classes.root}>
                <Sidebar />
                <div style={{ width: "100%" }}>
                    <OverallSummary />
                    <div
                        style={{
                            width: "100%",
                            zIndex: -1,
                            height: "calc(100% - (var(--app-header-height) + var(--app-overall-summary-height)))",
                        }}>
                        <SplitPane
                            ref={paneRef}
                            className={clsx(classes.splitPane, {
                                [classes.splitPaneShift]: props.open,
                            })}
                            style={{
                                backgroundColor: "var(--grey-background)",
                                paddingTop: "100px",
                            }}
                            split="horizontal"
                            defaultSize="45%"
                            onDragStarted={() => setDragging(true)}
                            onDragFinished={(val) => {
                                setDragging(false);
                                setDrawerHeight({ height: val + "px" });
                            }}
                            //onChange={(size) => setSize(window.innerHeight - size)}
                            minSize={window.innerHeight * 0.15}
                            maxSize={Math.min(-window.innerHeight * 0.2, -200)}
                            pane1Style={{
                                paddingBottom: "5px",
                            }}
                            pane2Style={{
                                overflowY: "scroll",
                                overflowX: "hidden",
                            }}>
                            <div
                                style={{
                                    display: "block",
                                    backgroundColor: "var(--grey-background)",
                                    width: "100%",
                                }}>
                                {/* Drawer Reusability  */}
                                {props.selectedLabourer && (
                                    <LabourerDrawerForm
                                        state={drawerProps}
                                        classes={classes.drawer}
                                        showFooter={false}
                                        closeform={(close) =>
                                            setDrawerProps({
                                                open: close,
                                                data: "",
                                                create: close,
                                            })
                                        }
                                        {...props}
                                        dynamicHeight={drawerHeight}
                                    />
                                )}
                                <div
                                    style={{
                                        display: "table",
                                    }}>
                                    <Title
                                        id="cmis-wo-overview-title"
                                        style={{
                                            display: "inline",
                                        }}>
                                        <FormattedMessage id="dashboard.title" defaultMessage="Work order overview" description="Dashboard title" />
                                        <DateDomain />
                                    </Title>
                                </div>
                                <MultidayGantt
                                    dateRange={props.dateRange}
                                    selectedLabourer={props.selectedLabourer}
                                    tasks={filteredData.tasks}
                                    technicians={filteredData.technicians}
                                />
                            </div>
                            <Tasks
                                tasks={filteredData.tasks}
                                dragging={dragging}
                                paneRef={pane2Ref}
                                filterTasklist={props.filterTasklist}
                                followUpTypes={props.followUpTypes}
                            />
                        </SplitPane>
                    </div>
                </div>
                <ShowOverlapsModal id="show-overlap-modal" />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        tasks: state.tasks.tasks,
        taskCounts: state.tasks.taskCounts,
        dateRange: state.domain.dateRange,
        selectedLabourer: state.gantt.selectedLabourer,
        open: state.dashboard.open,
        technicians: state.technicians,
        contracts: state.contracts,
        skills: state.skills,
        filter: state.dashboard.filter,
        zones: state.dashboard.zones,
        allStatuses: state.dashboard.allStatuses,
        followUpTypes: state.followUps ? state.followUps.followUpReasons : [],
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setSelectedLabourer,
            filterTasklist,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
